import React from 'react'

import { FiLink2 } from 'react-icons/fi'

import { subnav } from './Navigation.module.scss'

const Navigation = ({ 
  endpoint, 
  microcopy 
}) => (
  <nav className={ subnav }>
    <FiLink2 />
    { endpoint.params?.[0] && (
      <a href='#request'>
        { microcopy.text('reference.titles.request') }
      </a>
    )}
    { endpoint.responses?.[0] && (
      <a href='#response'>
        { microcopy.text('reference.titles.response') }
      </a>
    )}
    { endpoint.samples?.[0] && (
      <a href='#request-example'>
        { microcopy.text('reference.titles.request_example') }
      </a>
    )}
    { endpoint.defaultResponse?.resource && (
      <a href='#response-example'>
        { microcopy.text('reference.titles.response_example') }
      </a>
    )}        
  </nav>
)

export default Navigation